let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jRRNv")).then(() => parcelRequire('7l6f4'));